import React from 'react'
import './html-content.css'

export default function HTMLContent(props: {
  className?: string
  children: string
  'aria-label'?: string
}) {
  return (
    <div
      className={`html-content ${props.className ?? ''}`}
      dangerouslySetInnerHTML={{
        __html: props.children,
      }}
      aria-label={props['aria-label']}
    />
  )
}
